module.exports = __webpack_public_path__ + "static/media/doc1.0cb132c5.PNG";